import { parseMaterialDef } from '../materials';

export type MaterialParseResult = {
  type: 'material';
  value: number[];
};

/**
 * Detects `material_def(...)` function call syntax.
 *
 * Returns null if the value string is not a material_def call.
 */
export function parseMaterialType(valueStr: string): MaterialParseResult | null {
  if (!valueStr.startsWith('material_def(') || !valueStr.endsWith(')')) {
    return null;
  }
  return {
    type: 'material',
    value: parseMaterialDef(valueStr),
  };
}
